export interface AuthBridgeSession {
  token: string;
  expiresAt: string;
  tenantId: string;
  erpConnectionId: string;
  marketplaceKind: string;
  isNewTenant: boolean;
}

export interface AuthBridgeError {
  code: string;
  message: string;
}

export async function exchangeAppToken(
  authBridgeUrl: string,
  appToken: string,
  signal?: AbortSignal,
): Promise<AuthBridgeSession> {
  const response = await fetch(authBridgeUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ appToken }),
    ...(signal ? { signal } : {}),
  });

  if (!response.ok) {
    let payload: { error?: AuthBridgeError } = {};
    try {
      payload = await response.json();
    } catch {
      // ignore
    }
    const code = payload.error?.code ?? 'HTTP_ERROR';
    const message = payload.error?.message ?? `auth-bridge HTTP ${response.status}`;
    throw new AuthBridgeFailure(code, message, response.status);
  }
  return (await response.json()) as AuthBridgeSession;
}

export class AuthBridgeFailure extends Error {
  public readonly code: string;
  public readonly status: number;
  constructor(code: string, message: string, status: number) {
    super(message);
    this.code = code;
    this.status = status;
    this.name = 'AuthBridgeFailure';
  }
}
